import { apiInstances } from '../../../../libs';

const { post } = apiInstances.routesInstance;

export default async function assignRoute({ id_route, id_clouder }) {
  return post(`/routes/${id_route}/assign`, { id_clouder });
}
